export default "__VITE_ASSET__D$cHH3V1__"